<template>
  <div :class="{ web: webPage, mobile: !webPage }" class="app" id="app">
    <div v-if="webPage">
      <div>
        <Landing :scroll="scroll"/>
      </div>
      <div>
        <Features />
      </div>
      <div>
        <Plugin />
      </div>
      <div>
        <ToStart />
      </div>
      <div class="formSubmit" align="center">
        <div
          ref="demo"
          style="
            padding-top: 92px;
            font-family: 'Roboto Serif', serif;
            font-weight: 800;
            font-size: 50px;
            line-height: 59px;
          "
        >
          Ready to start your practice?
        </div>
        <div
          style="
            padding-top: 18px;
            font-family: 'Roboto';
            font-weight: 400;
            font-size: 20px;
            line-height: 24px;
          "
        >
          Book a demo with an EHR Specialist today!
        </div>
        <div style="padding-top: 100px" align="left">
          <el-row :gutter="60">
            <el-col :span="6" :offset="6"> First Name </el-col>
            <el-col :span="6"> Last Name </el-col>
          </el-row>
          <el-row :gutter="60">
            <el-col :span="6" :offset="6">
              <el-input v-model="firstName"></el-input>
            </el-col>
            <el-col :span="6">
              <el-input v-model="lastName"></el-input>
            </el-col>
          </el-row>
        </div>
        <div style="padding-top: 60px" align="left">
          <el-row :gutter="60">
            <el-col :span="6" :offset="6"> Email Address </el-col>
            <el-col :span="6"> Contact Number </el-col>
          </el-row>
          <el-row :gutter="60">
            <el-col :span="6" :offset="6">
              <el-input v-model="email"></el-input>
            </el-col>
            <el-col :span="6">
              <el-input v-model="number"></el-input>
            </el-col>
          </el-row>
        </div>
        <div style="padding-top: 60px" align="left">
          <el-row :gutter="60">
            <el-col :span="12" :offset="6"> How did you hear about us? </el-col>
          </el-row>
          <el-row :gutter="60">
            <el-col :span="12" :offset="6">
              <el-input v-model="source"></el-input>
            </el-col>
          </el-row>
        </div>
        <div style="padding-top: 60px; padding-bottom: 100px">
          <el-button style="background-color: #ffffff; color: #3e6161" @click="request()">
            Request a Demo Now
            <i class="el-icon-right el-icon--right" style="font-size: 16px"></i>
          </el-button>
        </div>
      </div>
      <div>
        <Footer />
      </div>

    </div>
    <div v-else>
      <div>
        <div>
          <LandingMobile :scrollMobile="scrollMobile"/>
        </div>
        <div>
          <FeaturesMobile />
        </div>
        <div>
          <PluginMobile />
        </div>
        <div>
          <ToStartMobile />
        </div>
        <div ref="demo1">
          <FormSubmitMobile/>
        </div>
        <div>
          <FooterMobile />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Landing from "../src/components/Landing";
import Features from "../src/components/Features";
import Plugin from "../src/components/Plugin";
import ToStart from "../src/components/ToStart";
import FormSubmit from "../src/components/FormSubmit";
import Footer from "../src/components/Footer";

import LandingMobile from "../src/components/mobile/Landing";
import FeaturesMobile from "../src/components/mobile/FeaturesMobile";
import PluginMobile from "../src/components/mobile/Plugin";
import ToStartMobile from "../src/components/mobile/ToStart";
import FormSubmitMobile from "../src/components/mobile/FormSubmit";
import FooterMobile from "../src/components/mobile/Footer";

import {
  SEND_REQUEST
} from '@/graphQL/mutations'

export default {
  components: {
    Landing,
    Features,
    Plugin,
    ToStart,
    Footer,
    LandingMobile,
    FeaturesMobile,
    PluginMobile,
    ToStartMobile,
    FormSubmitMobile,
    FooterMobile,
  },
  data() {
    return {
      screenWidth: window.innerWidth,
      webPage: true,
      firstName: undefined,
      lastName: undefined,
      email: undefined,
      number: undefined,
      source: undefined
    };
  },
  created() {
    window.addEventListener("resize", this.resizeHandler);
    this.resizeHandler();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  watch: {
    screenWidth(newValue) {
      console.log("current screen size: ", newValue);
      if (newValue > 650) {
        this.webPage = true;
      } else {
        this.webPage = false;
      }
      console.log("webPage: ", this.webPage);
    },
  },
  methods: {
    resizeHandler() {
      this.screenWidth = window.innerWidth;
    },
    async request(){
      if (!this.firstName || !this.lastName || !this.email || !this.number || !this.source){
        this.$message.error({
          message: 'Please fill all blank inputs'
        })
        return
      }
      try {
        const mutateObj = {
          input: {
            first_name: this.firstName,
            last_name: this.lastName,
            phone: this.number,
            email: this.email,
            source: this.source
          }
        }
        const result = await this.$apollo.mutate({
          mutation: SEND_REQUEST,
          variables: mutateObj,

        })
        if (result.data && result.data.send_demo_request){
          this.$message.success({
            message: 'Request sent successfully'
          })
        }
      } catch {
        this.$message.error({
          message: 'Please fill all blank inputs'
        })
      }
    },
    scroll(){
      this.$refs["demo"].scrollIntoView({
        behavior: "smooth"
      })
    },
    scrollMobile(){
      this.$refs["demo1"].scrollIntoView({
        behavior: "smooth"
      })
    }
  },
  name: "App",
};
</script>

<style scoped>
/* @import url("https://fonts.googleapis.com/css2?family=Roboto+Serif:wght@400|500|600|700|800&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@200|300|400"); */

.web {
  width: 1440px;
  margin: auto;
}

.mobile {
  width: 375px;
  margin: auto;
}

.roboto {
  font-family: "Roboto Serif", serif;
  font-size: 50px;
  line-height: 59px;
}

.app {
  font-family: Roboto;
}
</style>
